import Vue from 'vue';

const FETCH_PRODUCT_URL = '/product/fetch';
const ADMIN_LIST_PRODUCT_URL = '/product/admin/list';
const SET_OPTIONS_URL = '/product/set-options';
const SET_TYPE_URL = '/product/set-type';
const SET_SHOP_VISIBILITY_URL = '/product/set-shop-visibility';
const DELETE_PRODUCT_URL = '/product/';
const CATALOG_LIST_URL = '/product/catalog/list';

class ProductService {

    async fetch() {
        return await Vue.prototype.$axios.post(FETCH_PRODUCT_URL);
    }

    async getAdminList(data) {
        return await Vue.prototype.$axios.post(ADMIN_LIST_PRODUCT_URL, data);
    }

    async setOptions(data) {
        return await Vue.prototype.$axios.post(SET_OPTIONS_URL, data);
    }

    async setType(data) {
        return await Vue.prototype.$axios.post(SET_TYPE_URL, data);
    }

    async setShopVisibility(data) {
        return await Vue.prototype.$axios.post(SET_SHOP_VISIBILITY_URL, data);
    }

    async getCatalogList() {
        return await Vue.prototype.$axios.get(CATALOG_LIST_URL);
    }

    async deleteProduct(id) {
        return await Vue.prototype.$axios.delete(DELETE_PRODUCT_URL, {params: {id: id}});
    }
}

export default new ProductService();
